import {TRootState} from "types";

export const globalPerPageSelector = (state: TRootState) => state.userPreference.per_page;
export const globalProjectLayoutViewSelector = (state: TRootState) =>
	state.userPreference.project_layout_view;
